<template>
  <div class="creation-wrap">
    <div class="title">热点排行</div>
    <div class="afflatus-wrap">
      <div class="afflatus-box" @click="changeLabel(0)">
        <img src="@/assets/images/search_pressed.png" v-if="!activeLabel" />
        <img src="@/assets/images/search_normal.png" v-else />
      </div>
      <div class="afflatus-box" @click="changeLabel(1)">
        <img src="@/assets/images/good_pressed.png" v-if="activeLabel == 1" />
        <img src="@/assets/images/good_normal.png" v-else />
      </div>
      <!-- <div
        :class="[
          activeLabel === index ? 'active afflatus-box' : 'afflatus-box'
        ]"
        v-for="(item, index) in afflatusArr"
        :key="index"
        @click="changeLabel(index)"
      >
        <div class="content">
        </div>
      </div> -->
    </div>
    <div class="search" v-if="!activeLabel">
      <div class="date-content">
        <span class="desc"> 时间维度：</span>
        <span class="content">{{ dayContent }}</span>
      </div>
      <div class="afflatus-content" v-if="searchArr.length">
        <div
          class="content-box"
          v-for="(item, index) in searchArr"
          :key="index"
        >
          <div class="wrap-content">
            <div class="active sort" v-if="index == 0">
              <img src="@/assets/images/first.png" />
            </div>
            <div class="active1 sort" v-else-if="index == 1">
              <img src="@/assets/images/second.png" />
            </div>
            <div class="active2 sort" v-else-if="index == 2">
              <img src="@/assets/images/third.png" />
            </div>
            <div class="content">{{ item }}</div>
          </div>
        </div>
      </div>
      <div class="no-data" v-else>
        <img class="img" src="@/assets/images/img_table_no_data.png" />
        <div class="desc">暂无排行数据</div>
      </div>
    </div>
    <div class="map-wrap" v-else>
      <div class="week-map">
        <div class="week-title">本周推荐</div>
        <!-- 本周推荐地图 -->
        <div class="map-box" v-if="weekMap.length">
          <div
            class="content-box"
            v-for="(item, index) in weekMap"
            :key="index"
          >
            <img :src="item.cover" class="image" alt="" />
            <div class="content">
              <div class="content-title">{{ item.name }}</div>
              <div class="name">
                <!-- <i class="el-icon-user"> </i> -->
                <img src="@/assets/images/mini_label.png" />
                <span class="user"> {{ item.uinName }}</span>
              </div>
              <div class="uin_value">
                <span id="input">
                  <span class="uin-desc">迷你号： </span>
                  <span class="uin">{{ item.uin }}</span>
                </span>
                <span class="icon-copy-document" @click="copy(item.uin)">
                  <img src="@/assets/images/copy_count.png" />
                </span>
                <!-- <i class="el-icon-copy-document" @click="copy(item.uin)"> </i> -->
              </div>
              <div class="content-count">
                <div class="count">
                  <!-- <i class="el-icon-download"> </i> -->
                  <span class="icon-download">
                    <img src="@/assets/images/download_count.png" />
                  </span>
                  {{ item.downloadCount | rowGroup }}
                </div>
                <div class="count">
                  <span class="icon-thumb">
                    <img src="@/assets/images/zan.png" />
                  </span>
                  {{ item.likeCount | rowGroup }}
                </div>
                <div class="count">
                  <span class="icon-coin">
                    <img src="@/assets/images/select_count.png" />
                  </span>
                  {{ item.tipCount | rowGroup }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="nomap" v-else>
          <img class="img" src="@/assets/images/img_table_no_data.png" />
          <div class="desc">暂无推荐地图</div>
        </div>
      </div>
      <!-- 更多推荐 -->
      <div class="more-map">
        <div class="label-wrap">
          <div class="more-title">更多推荐</div>
          <div
            :class="[
              mapLabel === index ? 'active label-content' : 'label-content',
            ]"
            v-for="(item, index) in labelArr"
            :key="index"
            @click="changeMaplabel(index, item.id)"
          >
            <div class="item-name">{{ item.name }}</div>
            <div
              class="label-border"
              v-if="index + 1 !== labelArr.length"
            ></div>
          </div>
        </div>

        <div class="more-box">
          <!-- <div class="map-box" v-if="moreMap.length">
            <div
              class="content-box"
              v-for="(item, index) in moreMap"
              :key="index"
            >
              <img :src="item.cover" class="image" alt="" />
              <div class="content">
                <div class="content-title">{{ item.name }}</div>
                <div class="name">
                  <i class="el-icon-user"> </i>
                  <span class="user"> {{ item.uinName }}</span>
                </div>
                <div class="uin_value">
                  <i class="el-icon-copy-document" @click="copy(item.uin)"> </i>
                  <span id="input">{{ item.uin }}</span>
                </div>
                <div class="content-count">
                  <div class="count">
                    <i class="el-icon-download"> </i>
                    {{ item.downloadCount }}
                  </div>
                  <div class="count">
                    <i class="el-icon-thumb"> </i>
                    {{ item.likeCount }}
                  </div>
                  <div class="count">
                    <i class="el-icon-coin"> </i>
                    {{ item.tipCount }}
                  </div>
                </div>
              </div>
            </div>
          </div> -->
          <div class="map-box" v-if="moreMap.length">
            <div
              class="content-box"
              v-for="(item, index) in moreMap"
              :key="index"
            >
              <img :src="item.cover" class="image" alt="" />
              <div class="content">
                <div class="content-title">{{ item.name }}</div>
                <div class="name">
                  <!-- <i class="el-icon-user"> </i> -->
                  <img src="@/assets/images/mini_label.png" />
                  <span class="user"> {{ item.uinName }}</span>
                </div>
                <div class="uin_value">
                  <span id="input">
                    <span class="uin-desc">迷你号： </span>
                    <span class="uin">{{ item.uin }}</span>
                  </span>
                  <span class="icon-copy-document" @click="copy(item.uin)">
                    <img src="@/assets/images/copy_count.png" />
                  </span>
                  <!-- <i class="el-icon-copy-document" @click="copy(item.uin)"> </i> -->
                </div>
                <div class="content-count">
                  <div class="count">
                    <!-- <i class="el-icon-download"> </i> -->
                    <span class="icon-download">
                      <img src="@/assets/images/download_count.png" />
                    </span>
                    {{ item.downloadCount | rowGroup }}
                  </div>
                  <div class="count">
                    <span class="icon-thumb">
                      <img src="@/assets/images/zan.png" />
                    </span>
                    {{ item.likeCount | rowGroup }}
                  </div>
                  <div class="count">
                    <span class="icon-coin">
                      <img src="@/assets/images/select_count.png" />
                    </span>
                    {{ item.tipCount | rowGroup }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="no-moremap" v-else>
            <img class="img" src="@/assets/images/img_table_no_data.png" />
            <div class="desc">暂无推荐地图</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script src="dist/clipboard.min.js"></script>
<script>
import { getSearchData, getRecommonMap, getcommonMapfy } from '@/api/common.js';
import { logUrl } from '@/api/logUrl.js';
export default {
  data() {
    return {
      afflatusArr: [
        {
          title: '热门搜索',
        },
        {
          title: '精品地图',
        },
        // {
        //   title: '精品地图'
        // },
        // {
        //   title: '精品地图'
        // }
      ],
      labelArr: [],
      mapLabel: 0,
      typeId: 1,
      searchArr: [],
      weekMap: [],
      moreMap: [],
      activeLabel: 0,
      dayContent: '昨天',
    };
  },
  filters: {
    rowGroup(num) {
      if (num > 10000 || num === 10000) {
        return (num / 10000).toFixed(1) + '万';
      } else {
        return num;
      }
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      this.getSearch();
      await this.gtMapClassify();
      this.getWeekReMap();
      this.getMoreReMap();
      this.logPage();
    },
    //洞察页面初始化埋点
    logPage() {
      let data = {
        ts: Math.floor(new Date().getTime() / 1000),
        product: 71005,
        id: 71005,
        event_type: 'view',
        activity: 10024,
        scene_comp: 'Inspiration_Page',
      };
      logUrl(data);
    },
    //热门搜索点击埋点
    logSearch() {
      let data = {
        ts: Math.floor(new Date().getTime() / 1000),
        //    product: 71005,
        //    id: 71005,
        event_type: 'click',
        activity: 1024,
        scene_comp: 'Search_Button',
      };
      logUrl(data);
    },
    //精品按钮点击搜索埋点
    logMap() {
      let data = {
        ts: Math.floor(new Date().getTime() / 1000),
        product: 71005,
        id: 71005,
        event_type: 'click',
        activity: 10024,
        scene_comp: 'Boutique_Button',
      };
      logUrl(data);
    },
    //获取热门搜索数据
    async getSearch() {
      let data = {
        size: 10,
      };
      const res = await getSearchData(data);
      this.searchArr = res.data;
    },
    //获取地图分类
    async gtMapClassify() {
      let data = {};
      const res = await getcommonMapfy(data);
      if (res.data.length) {
        this.labelArr = res.data;
        this.typeId = this.labelArr[0].id;
      }
    },
    //获取本周精选地图数据
    async getWeekReMap() {
      let data = {
        column: 1,
        pageIndex: 1,
        pageSize: 4,
      };
      const res = await getRecommonMap(data);
      this.weekMap = res.data.rows;
    },
    //获取更加推荐地图
    async getMoreReMap() {
      let data = {
        column: 2,
        pageIndex: 1,
        pageSize: 6,
        typeId: this.typeId,
      };
      const res = await getRecommonMap(data);
      this.moreMap = res.data.rows;
    },
    changeMaplabel(index, id) {
      this.mapLabel = index;
      this.typeId = id;
      this.getMoreReMap();
    },
    changeLabel(index) {
      this.activeLabel = index;
      console.log(this.activeLabel);
      if (this.activeLabel) {
        this.logMap();
      } else {
        this.logSearch();
      }
    },
    //复制
    copy(uinId) {
      new ClipboardJS('.icon-copy-document', {
        text: function () {
          return uinId;
        },
      });
      this.$message.success('复制成功');
    },
  },
};
</script>
<style lang="scss" scoped>
.creation-wrap {
  .title {
    font-size: 20px;
    margin-top: 23px;
    color: #595959;
    margin-bottom: 24px;
  }
  .afflatus-wrap {
    display: flex;
    justify-content: flex-start;
    .afflatus-box {
      //width: 220px;
      //height: 120px;
      //font-size: 20px;
      //font-weight: 600;
      cursor: pointer;
      //border: 1px solid #ddd;
      margin-right: 14px;
      border-radius: 4px;
      // .el-icon-search::before {
      //   width: 30px !important;
      //   height: 30px !important;
      // }
    }
    .active.afflatus-box {
      background: #ddd;
    }
  }
  .date-content {
    display: flex;
    //justify-content: flex-end;
    margin-top: 24px;
    margin-bottom: 24px;
    font-size: 16px;
    color: #595959;
  }
  .afflatus-content {
    display: flex;
    justify-content: flex-start;
    margin-right: -30px;
    margin-top: 20px;
    flex-wrap: wrap;
    .content-box {
      //display: flex;
      display: flex;
      margin-right: 32px;
      margin-bottom: 24px;
      width: 300px;
      height: 67px;
      background: #fcfdff;
      border-radius: 4px;
      border: 1px solid #e8edf7;
      align-items: center;
      //justify-content: center;
      font-size: 18px;
      font-weight: 600;
      .wrap-content {
        margin-left: 25px;
        display: flex;
        align-items: center;
      }
      .active.sort {
        margin-right: 13px;
        padding-top: 6px;
      }
      .active1.sort {
        margin-right: 13px;
        padding-top: 6px;
      }
      .active2.sort {
        margin-right: 13px;
        padding-top: 6px;
      }
    }
  }
  .no-data {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 50px;
    padding-bottom: 40px;
    justify-content: center;
    .desc {
      margin-top: 15px;
      font-size: 16px;
    }
  }
  .map-wrap {
    margin-top: 24px;
    .week-map {
      .week-title {
        font-size: 16px;
        color: #595959;
        margin-bottom: 24px;
      }
    }
    .map-box {
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      .content-box {
        padding: 12px 0 12px 12px;
        display: flex;
        width: 469px;
        height: 123px;
        background: #fcfdff;
        border-radius: 4px;
        margin-bottom: 24px;
        margin-right: 24px;
        border: 1px solid #e8edf7;
        justify-content: flex-start;
        .image {
          width: 176px;
          height: 99px;
          margin-right: 14px;
        }
        .content {
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          .content-title {
            max-width: 256px;
            font-size: 18px;
            margin-bottom: 6px;
            color: #000000;
            overflow: hidden; /*超出隐藏*/
            text-overflow: ellipsis; /*文本超出显示省略号*/
          }
          .name {
            //margin-bottom: 7px;
            display: flex;
            font-size: 14px;
            margin-bottom: 5px;
            color: #8c8c8c;
            .el-icon-user {
              margin-right: 2px;
              padding-top: 2px;
            }
            .user {
              display: inline-block;
              white-space: nowrap; /*超出的空白区域不换行*/
              overflow: hidden; /*超出隐藏*/
              text-overflow: ellipsis; /*文本超出显示省略号*/
              max-width: 238px;
              margin-left: 6px;
            }
          }
          .uin_value {
            //margin-bottom: 7px;
            margin-bottom: 5px;
            vertical-align: middle;
            .el-icon-copy-document {
              margin-right: 6px;
              cursor: pointer;
            }
            .icon-copy-document {
              margin-right: 6px;
              cursor: pointer;
              img {
                margin-bottom: -5px;
              }
            }
            #input {
              color: #8c8c8c;
              font-size: 14px;
              .uin-desc {
                // margin-right: 4px;
              }
              .uin {
                margin-left: -6px;
              }
            }
          }

          .content-count {
            display: flex;
            font-size: 14px;
            color: #595959;
            max-width: 260px;
            margin-bottom: -7px !important;
            .count {
              margin-right: 20px;
              img {
                margin-bottom: -3px;
              }
            }
            .count:nth-child(3) {
              margin-right: 0;
            }
          }
        }
      }
    }
    .nomap {
      margin-top: 30px;
      padding-bottom: 10px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .desc {
        margin-top: 8px;
        font-size: 18px;
      }
      .intro-content {
        //vertical-align: middle;
        margin-top: 60px;
      }
    }
    .more-map {
      margin-top: 18px;
      margin-bottom: 90px;
      .more-title {
        margin-right: 24px;
        color: #595959;
        font-size: 16px;
      }
      .label-wrap {
        display: flex;
        justify-content: flex-start;
        margin-bottom: 24px;
        .label-content {
          cursor: pointer;
          display: flex;
          align-items: center;
          font-size: 16px;
        }
        .label-border {
          width: 2px;
          height: 14px;
          margin: 0 24px;
          background: #8c8c8c;
        }
        .active.label-content {
          color: #fd9b21;
          cursor: pointer;
        }
      }
      .more-box {
        .no-moremap {
          margin-top: 120px;
          padding-bottom: 10px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          .desc {
            margin-top: 8px;
            font-size: 18px;
          }
          .intro-content {
            //vertical-align: middle;
            margin-top: 60px;
          }
        }
        .map-box {
          display: flex;
          justify-content: flex-start;
          flex-wrap: wrap;
          .content-box {
            padding: 12px 0 12px 12px;
            display: flex;
            width: 469px;
            height: 123px;
            background: #fcfdff;
            border-radius: 4px;
            margin-bottom: 24px;
            margin-right: 24px;
            border: 1px solid #e8edf7;
            justify-content: flex-start;
            .image {
              width: 176px;
              height: 99px;
              margin-right: 14px;
            }
            .content {
              display: flex;
              flex-direction: column;
              justify-content: flex-start;
              .content-title {
                max-width: 256px;
                font-size: 18px;
                margin-bottom: 6px;
                color: #000000;
                overflow: hidden; /*超出隐藏*/
                text-overflow: ellipsis; /*文本超出显示省略号*/
              }
              .name {
                //margin-bottom: 7px;
                display: flex;
                font-size: 14px;
                margin-bottom: 5px;
                color: #8c8c8c;
                .el-icon-user {
                  margin-right: 2px;
                  padding-top: 2px;
                }
                .user {
                  display: inline-block;
                  white-space: nowrap; /*超出的空白区域不换行*/
                  overflow: hidden; /*超出隐藏*/
                  text-overflow: ellipsis; /*文本超出显示省略号*/
                  max-width: 238px;
                  margin-left: 6px;
                }
              }
              .uin_value {
                //margin-bottom: 7px;
                margin-bottom: 5px;
                vertical-align: middle;
                .el-icon-copy-document {
                  margin-right: 6px;
                  cursor: pointer;
                }
                .icon-copy-document {
                  margin-right: 6px;
                  cursor: pointer;
                  img {
                    margin-bottom: -5px;
                  }
                }
                #input {
                  color: #8c8c8c;
                  font-size: 14px;
                  .uin-desc {
                    // margin-right: 4px;
                  }
                  .uin {
                    margin-left: -6px;
                  }
                }
              }

              .content-count {
                display: flex;
                font-size: 14px;
                color: #595959;
                max-width: 260px;
                margin-bottom: -7px !important;
                .count {
                  margin-right: 20px;
                  img {
                    margin-bottom: -3px;
                  }
                }
                .count:nth-child(3) {
                  margin-right: 0;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
